module.exports = __webpack_public_path__ + "static/media/skill7_pos_es.2ec6cdb0.txt";